'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024101 from "./presto.-Presto-Router$$anon$101.js";
import * as $j_presto$002e$002dSigned$002dDocuments$002dHistory$002dPage$0024 from "./presto.-Signed-Documents-History-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$100() {
  this.bc2 = null;
  this.bbU = null;
  this.bbV = false;
  this.bc3 = null;
  this.bc4 = false;
  this.bc7 = null;
  this.bc0 = null;
  this.bc1 = false;
  this.bbW = null;
  this.bbX = false;
  this.bbY = null;
  this.bbZ = false;
  this.bc5 = false;
  this.bc6 = false;
  this.bc2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bc7 = "SignedDocumentsHistoryPage";
}
export { $c_Lpresto_PrestoRouter$$anon$100 as $c_Lpresto_PrestoRouter$$anon$100 };
$p = $c_Lpresto_PrestoRouter$$anon$100.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$100;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$100() {
}
export { $h_Lpresto_PrestoRouter$$anon$100 as $h_Lpresto_PrestoRouter$$anon$100 };
$h_Lpresto_PrestoRouter$$anon$100.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bc2;
});
$p.M = (function() {
  if ((!this.bbV)) {
    this.bbU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bbV = true;
  }
  return this.bbU;
});
$p.O = (function() {
  if ((!this.bc4)) {
    this.bc3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bc4 = true;
  }
  return this.bc3;
});
$p.E = (function() {
  return this.bc7;
});
$p.t = (function() {
  if ((!this.bc1)) {
    this.bc0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bc1 = true;
  }
  return this.bc0;
});
$p.N = (function() {
  if ((!this.bbX)) {
    this.bbW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bbX = true;
  }
  return this.bbW;
});
$p.Q = (function() {
  if ((!this.bbZ)) {
    this.bbY = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024101.$c_Lpresto_PrestoRouter$$anon$101();
    this.bbZ = true;
  }
  return this.bbY;
});
$p.v = (function() {
  if ((!this.bc6)) {
    this.bc5 = false;
    this.bc6 = true;
  }
  return this.bc5;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee611) => ((p) => \u03b4scrutinee611))($j_presto$002e$002dSigned$002dDocuments$002dHistory$002dPage$0024.$m_Lpresto_SignedDocumentsHistoryPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$100 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$100, "presto.PrestoRouter$$anon$100", ({
  Nx: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$100 as $d_Lpresto_PrestoRouter$$anon$100 };
//# sourceMappingURL=presto.-Presto-Router$$anon$100.js.map
